import {
  GETCUSTOMERWALLETCURRENCYLIST_SUCCESS,
  GETCUSTOMERWALLETCURRENCYLIST_FAILED,
  RESET_GETCUSTOMERWALLETCURRENCYLIST,
  LOADING_GETCUSTOMERWALLETCURRENCYLIST,
  NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCUSTOMERWALLETCURRENCYLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCUSTOMERWALLETCURRENCYLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCUSTOMERWALLETCURRENCYLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCUSTOMERWALLETCURRENCYLIST:
      return (state = initialState);
    default:
      return state;
  }
};
